export default {
  release: '18.5',
  date: 'October 2025',
  releasePostUrl: 'https://docs.gitlab.com/releases/18/gitlab-18-5-released/#this-months-notable-contributor-jose-gabriel-companioni-benitez',
  contributors: [
    {
      name: 'Jose Gabriel Companioni Benitez',
      gitlabUsername: 'elC0mpa',
    },
  ],
  writeUp: `In his blog post ["How GitLab Can Boost Your Professional Career"](https://compacompila.com/posts/gitlab-open-source-community/),
Jose shares: "For me, the main advantage that GitLab offers, from a professional development
point of view, is that it is open source." He adds, "For GitLab, it's important
that anyone can contribute, and for that reason, they have taken the contributor
onboarding process very seriously."

Jose's journey from first-time contributor in September to Notable Contributor
in October demonstrates the power of the GitLab collaborative community. Through
active participation in community office hours, Discord discussions, and pairing
sessions, Jose found a supportive environment that helped him quickly grow to a
level 3 contributor with diverse contributions spanning [documentation](https://gitlab.com/gitlab-org/cli/-/merge_requests/2392),
[code](https://gitlab.com/gitlab-org/terraform-provider-gitlab/-/merge_requests/2690), and community support.

The GitLab community offers a welcoming space where contributors
support one another and grow together. Whether you're just starting your open-source
journey or looking to deepen your skills, our community is here to help you succeed.

To learn more about contributing, see the [GitLab Contributor Platform](https://contributors.gitlab.com/).

Thank you, Jose, for your outstanding work! 🚀`,
};
